"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalBase = exports.Signal = void 0;
var signal_1 = require("./signal");
Object.defineProperty(exports, "Signal", { enumerable: true, get: function () { return signal_1.Signal; } });
Object.defineProperty(exports, "SignalBase", { enumerable: true, get: function () { return signal_1.SignalBase; } });
//# sourceMappingURL=index.js.map